import * as yup from 'yup';
import { get } from 'lodash';

import {
  emailRegex,
  emailValidConstant,
  phoneRegex,
  requiredConstant,
} from 'common/utils/constants';

export const IndividualFundingSchema = yup.object().shape({
  signatoryLegalName: yup.string().nullable().required(requiredConstant),
  dob: yup.string().nullable().required(requiredConstant),
  countryCode: yup.string().nullable().required(requiredConstant),
  phone: yup
    .string()
    .nullable()
    .required(requiredConstant)
    .matches(phoneRegex, 'Phone number is not valid'),
  email: yup
    .string()
    .nullable()
    .email(emailValidConstant)
    .required(requiredConstant)
    .matches(emailRegex, emailValidConstant),
  ssn: yup.string().nullable().required(requiredConstant),
  address1: yup.string().nullable().required(requiredConstant),
  // address2: yup.string().nullable().required(requiredConstant),
  // state: yup.string().nullable().required(requiredConstant),
  // country: yup.string().nullable().required(requiredConstant),
  zip: yup.string().nullable().required(requiredConstant),
});

export const EntityFundingSchema = yup.object().shape({
  fundingEntityLegalName: yup.string().nullable().required(requiredConstant),
  signatoryLegalName: yup.string().nullable().required(requiredConstant),
  countryCode: yup.string().nullable().required(requiredConstant),
  phone: yup
    .string()
    .nullable()
    .matches(phoneRegex, 'Phone number is not valid')
    .required(requiredConstant),
  email: yup
    .string()
    .nullable()
    .email(emailValidConstant)
    .matches(emailRegex, emailValidConstant)
    .required(requiredConstant),
  ssn: yup.string().nullable().required(requiredConstant),
  address1: yup.string().nullable().required(requiredConstant),
  // address2: yup.string().nullable().required(requiredConstant),
  // state: yup.string().nullable().required(requiredConstant),
  // country: yup.string().nullable().required(requiredConstant),
  zip: yup.string().nullable().required(requiredConstant),
});

export const SubscriptionSchema = yup.object().shape({
  investmentAmount: yup
    .number()
    .positive()
    .nullable(true)
    .required(requiredConstant)
    .transform((v, o) => (o === '' ? null : v))
    .min(10000, 'Minimum allowed amount is US$ 10,000')
    .test(
      'multiply',
      'Please enter amount in multiples of US$ 1000s only',
      (value) => value !== undefined && value !== null && value % 1000 === 0,
    ),
  subscriberName: yup.string().nullable().required(requiredConstant),
  subscriberEinOrSSN: yup.string().nullable().required(requiredConstant),
});

export const ReInvestFullSubscriptionSchema = (context: any) => {
  return yup.object().shape({
    investmentAmount: yup
      .number()
      .positive()
      .nullable(true)
      .required(requiredConstant)
      .transform((v, o) => (o === '' ? null : v))
      .min(
        get(context, 'amount', 0),
        `Minimum allowed amount is US$ ${get(context, 'amount', 0)}`,
      ),
    // .test(
    //   'multiply',
    //   'Please enter amount in multiples of US$ 1000s only',
    //   (value) => value !== undefined && value !== null && value % 1000 === 0,
    // ),
    subscriberName: yup.string().nullable().required(requiredConstant),
    subscriberEinOrSSN: yup.string().nullable().required(requiredConstant),
  });
};

export const ReInvestPartialSubscriptionSchema = (context: any) => {
  return yup.object().shape({
    investmentAmount: yup
      .number()
      .positive()
      .nullable(true)
      .required(requiredConstant)
      .transform((v, o) => (o === '' ? null : v))
      .min(1, 'Minimum allowed amount is US$ 1')
      .test(
        'less-than',
        `Please enter amount less than US$ ${get(context, 'amount')}`,
        (value) =>
          value !== undefined &&
          value !== null &&
          value < get(context, 'amount'),
      ),
    // .test(
    //   'multiply',
    //   'Please enter amount in multiples of US$ 1000s only',
    //   (value) => value !== undefined && value !== null && value % 1000 === 0,
    // ),
    subscriberName: yup.string().nullable().required(requiredConstant),
    subscriberEinOrSSN: yup.string().nullable().required(requiredConstant),
  });
};

export const WireInstructionSchema = yup.object().shape({
  transactionId: yup
    .string()
    .nullable()
    .required('Please Upload Wire Reciept or Enter the transaction id.'),
});

export const WireInstructionSchemaNotRequired = yup.object().shape({
  transactionId: yup.string().nullable(),
});
